<template>
  <div :class="{
    'app-base': true,
    'text-center': !shopObj,
    'center-main-window': !shopObj || noDash
  }">
    <PendingChangeModal @revert="revert" @stay="stay" v-if="showPendingChangeModal" />
    <Toast />

    <div class="top-bar" v-if="!noTopBar">
      <Brand v-if="!shopObj || noDash" />
      <div class="container d-flex" v-else>
        <div class="toggle-menu" @click="toggleMenu"><IconMenu height="24" /></div>
        <div class="search-bar">
          <Alert v-if="selfUninstalled" class="alert-danger" icon="IconImportant" title="As per your request, Superchargify's code has been removed from your store &rsaquo;" titleLink="uninstall" />
        </div>
        <UserBar />
      </div>
    </div>

    <div class="left-menu-drop-shadow" v-if="showMenu" @click="toggleMenu">
      <div><span><IconClose height="30" /></span></div>
    </div>

    <transition name="slide-left" mode="out-in">
      <div class="left-menu" v-if="showLeftMenu">
        <div class="left-menu-main">
          <Brand :close="!bigScreen" @toggleMenu="toggleMenu" :routeName="logoLink" />
          <DashMenu class="mt-2" />
          <div class="alert alert-attention mt-2 coming-new">
            <p class="mb-0"><strong>New in Superchargify</strong> &mdash; Error Monitoring<br><router-link class="alert-link" :to="{ name: 'error_monitoring' }">Try now &rarr;</router-link></p>
          </div>
          <div class="alert alert-attention mt-2 coming-new">
            <p class="mb-0"><strong>New in Superchargify</strong> &mdash; AMP Preview Tool<br><a target="_blank" rel="noopener" href="https://preview.superchargify.com/" class="alert-link">Try now &rarr;</a></p>
          </div>
          <div class="alert alert-attention mt-2 coming-new">
            <p class="mb-0"><strong>New in Superchargify</strong> &mdash; Custom CSS for AMP<br><router-link class="alert-link" :to="{ name: 'amp_custom_css' }">Try now &rarr;</router-link></p>
          </div>
          <Footer class="mt-4 pb-4" />
        </div>
      </div>
    </transition>

    <div class="main-alignment main-window">
      <div class="container">
        <router-view v-if="!error"></router-view>
        <ErrorLayout v-else />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import DashMenu from '@/components/DashMenu'
import Footer from '@/components/Footer'
import UserBar from '@/components/UserBar'
import Brand from '@/components/Brand'
import PendingChangeModal from '@/components/PendingChangeModal'
import Toast from '@/components/Toast'

import ErrorLayout from '@/layouts/ErrorLayout'

import { EventBus } from '@/utils/event-bus'

export default {
  components: {
    DashMenu,
    Footer,
    UserBar,
    Brand,
    ErrorLayout,
    PendingChangeModal,
    Toast
  },
  data: function () {
    return {
      showMenu: false,
      showPendingChangeModal: false
    }
  },
  computed: {
    ...mapState([ 'shopObj', 'error', 'selfUninstalled' ]),
    noTopBar: function () {
      if (this.currentRoutePath.startsWith('/onboarding')) return true

      return false
    },
    bigScreen: function () {
      return ![ 'lg', 'md', 'sm' ].includes(this.$mq)
    },
    showLeftMenu: function () {
      if (this.noDash) return false
      if (!this.shopObj) return false
      if (this.bigScreen) return true
      if (this.showMenu) return true

      return false
    },
    noDash: function () {
      if (this.currentRoutePath.startsWith('/onboarding')) return true
      if (this.currentRoutePath.startsWith('/setup')) return true
      if (this.currentRoutePath.startsWith('/login')) return true
      if (this.currentRouteName === '404') return true

      return false
    },
    currentRoutePath: function () {
      return this.$route.path
    },
    currentRouteName: function () {
      return this.$route.name
    },
    logoLink: function () {
      if (!this.noDash || this.currentRouteName === '404') return 'home'

      return this.currentRouteName
    }
  },
  methods: {
    ...mapActions([ 'getClient' ]),
    toggleMenu: function () {
      this.showMenu = !this.showMenu
    },
    revert: function () {
      this.$store.commit('REVERT_CHANGES')
      this.showPendingChangeModal = false

      EventBus.$emit('pendingchange:action', 'revert')
    },
    stay: function () {
      this.showPendingChangeModal = false

      EventBus.$emit('pendingchange:action', 'stay')
    }
  },
  beforeRouteUpdate: function (to, from, next) {
    if (this.showMenu) this.showMenu = false

    next()
  },
  beforeRouteLeave: function (to, from, next) {
    if (this.showMenu) this.showMenu = false

    next()
  },
  created: async function () {
    EventBus.$on('pendingchange:show', () => {
      this.showPendingChangeModal = true
    })

    const response = await this.getClient()

    if (response && this.$ga) {
      this.$ga.set('userId', response.shopObj.myshopify_domain)
    }
  }
}
</script>

<style lang="scss">
.coming-new {
  border-radius: 0!important;
}
</style>
